//export const baseUrl = 'http://89.108.122.152/api_new.php'
export const baseUrl = '/api_new.php'
